import type { SxProps, Theme } from '@mui/material';

type Align = 'left' | 'right';

export const getBubbleWrapperSx =
  (align: Align): SxProps<Theme> =>
  (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    fontSize: '0.78125rem',
    lineHeight: 1.55,
    alignItems: align === 'right' ? 'flex-end' : 'flex-start',
    '&:hover .sidekick-copy, &:focus-within .sidekick-copy': { opacity: 1 },
    color: theme.palette.custom.OV.sys.onBackground,
  });

export const getBubbleBodySx =
  (align: Align): SxProps<Theme> =>
  (theme) => ({
    p: 0,
    border: 0,
    background: 'transparent',
    maxWidth: align === 'right' ? '86%' : '100%',
    textAlign: align === 'right' ? 'right' : 'left',
    color:
      align === 'right'
        ? theme.palette.custom.OV.sys.onSurfaceVariant
        : theme.palette.custom.OV.sys.onBackground,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    '& strong': { fontWeight: 700 },
    '& code': {
      fontFamily: 'monospace',
      fontSize: '0.6875rem',
      backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
      border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
      borderRadius: '0.25rem',
      padding: '0 0.25rem',
    },
    '& ul': {
      margin: '0.375rem 0 0',
      paddingLeft: '1.125rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.3125rem',
    },
    '& p': { margin: '0 0 0.5rem' },
    '& p:first-of-type': { marginTop: 0 },
    '& p:last-of-type': { marginBottom: 0 },
  });

export const bubbleLabelSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
});

export const copyButtonSx: SxProps<Theme> = (theme) => ({
  mt: 0.25,
  width: '1.25rem',
  height: '1.25rem',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  opacity: 0,
  transition: 'opacity 120ms ease',
  '&:focus-visible': { opacity: 1 },
});

export const getMessageMetaWrapperSx =
  (align: Align): SxProps<Theme> =>
  (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: align === 'right' ? 'flex-end' : 'flex-start',
    '&:hover .sidekick-date, &:focus-within .sidekick-date': {
      opacity: 1,
      visibility: 'visible',
    },
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
  });

export const messageMetaCaptionSx: SxProps<Theme> = (theme) => ({
  fontSize: '0.6875rem',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
});

export const messageMetaDateSx: SxProps<Theme> = (theme) => ({
  fontSize: '0.6875rem',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  opacity: 0,
  visibility: 'hidden',
  transition: 'opacity 120ms ease',
});
